import { createFileRoute, redirect } from '@tanstack/react-router';
import OrganisationDetailClient from '@/app/organisations/[id]/organisation-detail-client';
import { getSessionJwt } from '@/services/auth';

export const Route = createFileRoute('/organisations/$organisationId')({
  component: OrganisationDetail,
  beforeLoad: () => {
    if (!getSessionJwt()) {
      throw redirect({ to: '/login' });
    }
  },
});

function OrganisationDetail() {
  const { organisationId } = Route.useParams();
  return <OrganisationDetailClient organisationId={organisationId} />;
}

